"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidChainIdError = exports.ClientChainNotConfiguredError = exports.ChainNotFoundError = exports.ChainMismatchError = exports.ChainDoesNotSupportContract = void 0;
const base_js_1 = require("./base.js");
class ChainDoesNotSupportContract extends base_js_1.BaseError {
  constructor(_ref) {
    let {
      blockNumber,
      chain,
      contract
    } = _ref;
    super("Chain \"".concat(chain.name, "\" does not support contract \"").concat(contract.name, "\"."), {
      metaMessages: ['This could be due to any of the following:', ...(blockNumber && contract.blockCreated && contract.blockCreated > blockNumber ? ["- The contract \"".concat(contract.name, "\" was not deployed until block ").concat(contract.blockCreated, " (current block ").concat(blockNumber, ").")] : ["- The chain does not have the contract \"".concat(contract.name, "\" configured.")])]
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'ChainDoesNotSupportContract'
    });
  }
}
exports.ChainDoesNotSupportContract = ChainDoesNotSupportContract;
class ChainMismatchError extends base_js_1.BaseError {
  constructor(_ref2) {
    let {
      chain,
      currentChainId
    } = _ref2;
    super("The current chain of the wallet (id: ".concat(currentChainId, ") does not match the target chain for the transaction (id: ").concat(chain.id, " \u2013 ").concat(chain.name, ")."), {
      metaMessages: ["Current Chain ID:  ".concat(currentChainId), "Expected Chain ID: ".concat(chain.id, " \u2013 ").concat(chain.name)]
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'ChainMismatchError'
    });
  }
}
exports.ChainMismatchError = ChainMismatchError;
class ChainNotFoundError extends base_js_1.BaseError {
  constructor() {
    super(['No chain was provided to the request.', 'Please provide a chain with the `chain` argument on the Action, or by supplying a `chain` to WalletClient.'].join('\n'));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'ChainNotFoundError'
    });
  }
}
exports.ChainNotFoundError = ChainNotFoundError;
class ClientChainNotConfiguredError extends base_js_1.BaseError {
  constructor() {
    super('No chain was provided to the Client.');
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'ClientChainNotConfiguredError'
    });
  }
}
exports.ClientChainNotConfiguredError = ClientChainNotConfiguredError;
class InvalidChainIdError extends base_js_1.BaseError {
  constructor(_ref3) {
    let {
      chainId
    } = _ref3;
    super("Chain ID \"".concat(chainId, "\" is invalid."));
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 'InvalidChainIdError'
    });
  }
}
exports.InvalidChainIdError = InvalidChainIdError;
//# sourceMappingURL=chain.js.map